import { c as _c } from "react/compiler-runtime";
// `<HandlePill>` — rounded chip displaying a Morfi or X handle. Used in
// gift cards, thesis attribution, profile shares.
//
// The platform glyph (Morfi favicon or X logo) is rendered as a fixed-size
// element so it sits on the optical centre of the handle text. The X
// glyph used to be a Unicode `𝕏` text character which floats high and
// breaks alignment — replaced with the canonical X SVG path inlined from
// `frontend/public/assets/x-logo.svg`.

import { OG_TOKENS } from '../tokens';
import { OgLogomark } from './og-logomark';
const GLYPH_SIZE: number = 22;

// X logo path — inlined verbatim from `public/assets/x-logo.svg`
// (viewBox `0 0 300 271`). Fill is overridden to white so it shows on
// the black pill background.
const X_LOGO_PATH_D = 'M236.021 0H282.006L181.039 115L299 271H206.431L133.955 176.2L50.9827 271H4.998L111.962 148L-1 0H93.8684L159.347 86.6L236.021 0ZM219.926 244H245.418L80.4728 26H53.082L219.926 244Z';
function XLogo() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg width={GLYPH_SIZE} height={GLYPH_SIZE} viewBox="0 0 300 271" xmlns="http://www.w3.org/2000/svg" style={t0} role="img" aria-label="X"><path d={X_LOGO_PATH_D} fill="#ffffff" /></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export interface HandlePillProps {
  handle: string;
  platform?: 'morfi' | 'x';
}
export function HandlePill(props) {
  const $ = _c(11);
  const isX = props.platform === "x";
  const t0 = isX ? "#000000" : OG_TOKENS.brand800;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 18px",
      borderRadius: 9999,
      background: t0,
      color: "#ffffff",
      fontSize: 26,
      fontWeight: 500
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isX) {
    t2 = isX ? <XLogo /> : <OgLogomark size={GLYPH_SIZE} />;
    $[2] = isX;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.handle) {
    t4 = <span style={t3}>{props.handle}</span>;
    $[5] = props.handle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <div style={t1}>{t2}{t4}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}